import { Commons } from './commons'
import { Events } from './events'
import defaultPreferences from './raws/defaultPreferences.json'
import keysNotToCleanWhenLogout from './raws/keysNotToCleanWhenLogout.json'
import createActivityDetector from 'activity-detector'

let activityDetector

class QuickStorage {
  static init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    if (window.initiatedQuickStorage) return
    window.initiatedQuickStorage = true
    QuickStorage.loadInMemory()
    QuickStorage.initListener()
    QuickStorage.listenEventsToStoreFullDb()
    QuickStorage.loadUserPreferences()
  }

  static loadInMemory() {
    const storage = { ...localStorage }
    window.quick_storage = {}
    const keys = Object.keys(storage)
    keys.forEach(key => {
      try {
        const parsed = JSON.parse(storage[key])
        window.quick_storage[key] = parsed
      } catch (error) {
        console.log(error)
      }
    })
  }

  static loadUserPreferences() {
    const userPreferences = window.userPreferences || defaultPreferences
    Object.keys(userPreferences).forEach(key => {
      const stored = QuickStorage.getStored(key)
      if (Commons.isEmpty(stored)) return
      userPreferences[key] = stored
    })
    window.userPreferences = userPreferences
  }

  static loadPreferencesFromUserData(userData) {
    console.log(userData)
    const metadata = userData?.metaData?.metadata || {}
    const {
      xbetAccountId,
      betwinnerAccountId,
      melbetAccountId,
      eightStarzAccountId,
      oneWinAccountId,
    } = metadata
    if (xbetAccountId) QuickStorage.storeData('xbetAccountId', xbetAccountId)
    if (betwinnerAccountId)
      QuickStorage.storeData('betwinnerAccountId', betwinnerAccountId)
    if (melbetAccountId)
      QuickStorage.storeData('melbetAccountId', melbetAccountId)
    if (eightStarzAccountId)
      QuickStorage.storeData('eightStarzAccountId', eightStarzAccountId)
    if (oneWinAccountId)
      QuickStorage.storeData('oneWinAccountId', oneWinAccountId)
    QuickStorage.loadUserPreferences()
  }

  static initListener() {
    Events.handleEvent('user_connected', userData => {
      QuickStorage.storeData('user_connected', true)
      this.loadPreferencesFromUserData(userData)
    })
    Events.handleEvent('logout_requested', () => {
      QuickStorage.storeData('user_connected', false)
      QuickStorage.cleanStoredData()
    })
    Events.handleEvent('login_done', userData => {
      QuickStorage.storeData('user_connected', true)
      this.loadPreferencesFromUserData(userData)
    })
    Events.handleEvent('registration_done', () => {
      QuickStorage.storeData('user_connected', true)
    })
    Events.handleEvent('worker_activated', async () => {
      const userData = await new Promise(resolve => {
        Events.sendDataRequest('userData', resolve)
        setTimeout(resolve, 1000, null)
      })
      const userConnected = !!userData?.reference
      QuickStorage.storeData('user_connected', userConnected)
    })
    Events.handleEvent('request:userPreferences', ({ responseId }) => {
      if (!window.userPreferences) QuickStorage.loadUserPreferences()
      Events.dispatchEvent(responseId, window.userPreferences)
    })
    Events.handleEvent('request:platformData', ({ responseId }) => {
      let platform = `Kingrecharge Web ${Commons.getMobileOperatingSystem()}`
      if (window.isIframe) platform = 'Application Kingrecharge'
      Events.dispatchEvent(responseId, { platform })
    })
    Events.handleEvent('user_preferences_setted', async newData => {
      Object.keys(newData).forEach(key => {
        QuickStorage.storeData(key, newData[key])
      })
      QuickStorage.loadUserPreferences()
      Events.dispatchEvent('user_preferences_updated', window.userPreferences)
    })
  }

  static storeData(name, value) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.quick_storage[name] = Commons.changeToJson(value)
    // window.localStorage.setItem(name, JSON.stringify(value))
    // QuickStorage.loadInMemory()
  }

  static removeStored(name) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.quick_storage[name] = undefined
  }

  static storeAllDbFromMemoryToLocalStorage() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    if (!window.quick_storage) return
    const keys = Object.keys(window.quick_storage)
    keys.forEach(key => {
      const dataToSave = JSON.stringify(window.quick_storage[key])
      window.localStorage.setItem(key, dataToSave)
    })
  }

  static getStored(name) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    if (!window.quick_storage) return null
    const data = window.quick_storage[name]
    if (!data) return null
    return structuredClone(data)
  }

  static checkStored(name) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return false
    return Object.hasOwn(window.quick_storage, name)
  }

  static cleanStoredData() {
    const notToClear = {}
    keysNotToCleanWhenLogout.forEach(key => {
      notToClear[key] = QuickStorage.getStored(key)
    })
    window.localStorage.clear()
    keysNotToCleanWhenLogout.forEach(key => {
      QuickStorage.storeData(key, notToClear[key])
    })
    QuickStorage.loadInMemory()
  }

  static listenEventsToStoreFullDb() {
    if (activityDetector) return
    activityDetector = createActivityDetector({
      timeToIdle: 5000,
    })

    activityDetector.on('idle', () => {
      console.log(
        'The user is not interacting with the page - will write quick_storage to memory',
      )
      QuickStorage.storeAllDbFromMemoryToLocalStorage()
    })

    activityDetector.on('active', () => {
      console.log(
        'The user is using the page - will write quick_storage to memory',
      )
      QuickStorage.storeAllDbFromMemoryToLocalStorage()
    })

    window.addEventListener('beforeunload', () => {
      console.log('beforeunload - will write quick_storage to memory')
      QuickStorage.storeAllDbFromMemoryToLocalStorage()
    })
    window.addEventListener('focus', () => {
      console.log('focus - will write quick_storage to memory')
      QuickStorage.storeAllDbFromMemoryToLocalStorage()
    })
    window.addEventListener('resume', () => {
      console.log('resume - will write quick_storage to memory')
      QuickStorage.storeAllDbFromMemoryToLocalStorage()
    })
    window.addEventListener('blur', () => {
      console.log('blur - will write quick_storage to memory')
      QuickStorage.storeAllDbFromMemoryToLocalStorage()
    })
  }
}

export { QuickStorage }
